module.exports = __webpack_public_path__ + "img/10.97ef70a1.jpg";